/**
 * Cleans up a URL string by removing trailing slashes and hash fragments
 */
export function cleanupUrlSuffix(url: string): string {
  return url.replace(/[/#]+\/?$/, '')
}
